<template>
    <div>
  
      <div class="timestamp-converter">
        <h4>时间戳转换为时间</h4>
    <el-row>
      <el-col :span="8">
        <el-input v-model="timestamp" placeholder="请输入毫秒时间戳" />
      </el-col>
      <el-col :span="6">
        <el-button type="primary" @click="convertTimestamp">转换为UTC时间</el-button>
      </el-col>
      <el-col :span="8">
        <span>{{ convertedTime }}</span>
      </el-col>
    </el-row>
    <hr />

    <h4> 时间转换为时间戳 // 默认输入的是UTC时间</h4>
    <el-row>
      <el-col :span="8">
        <el-input v-model="timeInput" placeholder="请输入时间 (YYYY-MM-DD HH:mm:ss)" />
      </el-col>
      <el-col :span="6">
        <el-button type="primary" @click="convertTime">转换为时间戳</el-button>
      </el-col>
      <el-col :span="8">
        <span>{{ convertedTimestamp }}</span>
      </el-col>
    </el-row>
  </div>
  <hr>
    </div>
  </template>
  

  <script>
export default {
  data() {
    return {
      timestamp: '',
      convertedTime: '',
      timeInput: '',
      convertedTimestamp: '',
    };
  },
  methods: {
    convertTimestamp() {
      const timestamp = parseInt(this.timestamp);
      if (!isNaN(timestamp)) {
        const date = new Date(timestamp);
        const year = date.getUTCFullYear();
        const month = this.formatNumber(date.getUTCMonth() + 1);
        const day = this.formatNumber(date.getUTCDate());
        const hours = this.formatNumber(date.getUTCHours());
        const minutes = this.formatNumber(date.getUTCMinutes());
        const seconds = this.formatNumber(date.getUTCSeconds());

        this.convertedTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      } else {
        this.convertedTime = '无效的时间戳';
      }
    },
    convertTime() {
      const inputTime = new Date(this.timeInput + " UTC"); // 指定输入的时间就是utc 避免不必要的时区转换, 反而麻烦
      if (!isNaN(inputTime)) {
        this.convertedTimestamp = inputTime.getTime().toString();
      } else {
        this.convertedTimestamp = '无效的时间';
      }
    },
    formatNumber(number) {
      return number.toString().padStart(2, '0');
    },
  },
};
</script>
  
  <style>
  .timestamp-converter {
    margin: 20px;
  }
  </style>